var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cC_OhLJ88BS-DCCO67K8x"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website-main@altis-2i"]={id:"cC_OhLJ88BS-DCCO67K8x"};
      